export default __webpack_public_path__ + "static/media/carbon-flow-shema-it.5a73f0be.jpg";